<div class="program-share" [class.open]="isOpen">
  <button type="button" class="program-share-toggle" (click)="toggle($event)" [attr.aria-expanded]="isOpen" aria-label="Share">
    <i class="material-symbols-outlined" aria-hidden="true">share</i>
  </button>
  <div #popup class="program-share-popup" *ngIf="isOpen" (click)="$event.stopPropagation()">
    <div class="program-share-icons">
      <a [href]="links.facebook" target="_blank" rel="noopener" class="program-share-link" aria-label="Share on Facebook">
        <app-icon name="facebook"></app-icon>
      </a>
      <a [href]="links.linkedin" target="_blank" rel="noopener" class="program-share-link" aria-label="Share on LinkedIn">
        <app-icon name="linkedin"></app-icon>
      </a>
      <a [href]="links.whatsapp" target="_blank" rel="noopener" class="program-share-link" aria-label="Share on WhatsApp">
        <i class="fa fa-brands fa-whatsapp" aria-hidden="true"></i>
      </a>
      <a [href]="links.email" class="program-share-link" aria-label="Share via Email">
        <i class="material-symbols-outlined" aria-hidden="true">mail</i>
      </a>
    </div>
    <div class="program-share-copy">
      <input type="text" readonly [value]="shareUrl" (click)="$any($event.target).select()" aria-label="Shareable link" />
      <button type="button" (click)="copyLink($event)">{{ copied ? 'Copied' : 'Copy' }}</button>
    </div>
  </div>
</div>
